import React, { useEffect, useState } from 'react';
import { usePostgrest } from 'src/services/postgrest-provider';
import { RequestStatus } from "src/shared/enums";
import { ServiceRecord } from '../services/full-report';
import { ExposedServices } from './ExposedServices';

export const ExposedServicesWithApi:React.FC = () => {
  const postgrest = usePostgrest();
  const [reqStatus, setReqStatus] = useState(RequestStatus.Pending);
  const [data, setData] = useState([] as ServiceRecord[]);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => getData(), []);

  const getData = () => {
    postgrest
      .GetTable('services')
      .then((res) => {
        if (res.type === "success"){
          setReqStatus(RequestStatus.Success);
          setData(res.data);
        } else if (res.type === "error") {
          console.error(res.message);
          setReqStatus(RequestStatus.Error);
        }
      })
  }
  return (
    <ExposedServices data={data} status={reqStatus} />
  )
}